import "./loader.css"
import 'animate.css'

const Loader = () => {
    return (
        <img class="loader animate__animated animate__fadeOut" src="https://preview.redd.it/zyszxggj0h271.gif?width=480&auto=webp&s=8db0fbb67bf3a809f0da0688b4634a2811404bee" id="loader" />
    )
}

export default Loader